(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-v2"]) return;
  try {
    
  (function () {
    var drawer = document.getElementById('MaskdNavDrawer');
    if (!drawer) return;

    document.querySelectorAll('[data-drawer-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        drawer.showModal();
      });
    });

    document.querySelectorAll('[data-drawer-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        drawer.close();
      });
    });

    drawer.addEventListener('click', function (event) {
      if (event.target === drawer) {
        drawer.close();
      }
    });

    var searchOverlay = document.getElementById('MaskdSearchOverlay');
    var searchInput = searchOverlay ? searchOverlay.querySelector('[data-search-input]') : null;
    var searchResults = searchOverlay ? searchOverlay.querySelector('[data-search-results]') : null;

    if (searchOverlay) {
      var searchCloseTimer = null;

      var openSearch = function () {
        clearTimeout(searchCloseTimer);
        searchOverlay.showModal();
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            searchOverlay.classList.add('is-open');
          });
        });
        if (searchInput) searchInput.focus();
      };

      var closeSearch = function () {
        searchOverlay.classList.remove('is-open');
        clearTimeout(searchCloseTimer);
        searchCloseTimer = setTimeout(function () {
          searchOverlay.close();
        }, 350);
      };

      document.querySelectorAll('[data-search-open]').forEach(function (button) {
        button.addEventListener('click', openSearch);
      });

      document.querySelectorAll('[data-search-close]').forEach(function (button) {
        button.addEventListener('click', closeSearch);
      });

      searchOverlay.addEventListener('click', function (event) {
        if (event.target === searchOverlay) {
          closeSearch();
        }
      });

      searchOverlay.addEventListener('close', function () {
        searchOverlay.classList.remove('is-open');
        if (searchInput) searchInput.value = '';
        if (searchResults) searchResults.innerHTML = '';
      });
    }

    function linkWillNavigate(link, event) {
      // Only <a> elements can navigate the page at all.
      if (link.tagName !== 'A') return false;

      var href = link.getAttribute('href');
      // No href, or a bare "#" placeholder, does not navigate.
      if (!href || href === '#') return false;

      // A modifier key or target="_blank" opens the destination in a new
      // tab/window, leaving this page in place -- so the click animation
      // should still run here.
      if (event.metaKey || event.ctrlKey || event.shiftKey || link.target === '_blank') {
        return false;
      }

      return true;
    }

    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest('.maskd-strike-link');
        if (!link) return;

        // A click that will navigate away is always cut short by the page
        // unload, so its animation is barely visible -- but it still lands
        // alongside the destination page's own aria-current-driven
        // maskd-strike-draw animation, causing a visible double-strike.
        // Skip the click-driven classes entirely for navigating links and
        // let the page-load animation on the destination be the only one.
        if (linkWillNavigate(link, event)) return;

        // Scope to the nearest strike group (header nav, drawer nav, or
        // collection filters) so striking a link in one group never
        // un-strikes the active link in another.
        var group = link.closest('nav, .collection-page__filters') || document;
        var struck = group.querySelectorAll(
          ".maskd-strike-link[aria-current='page'], .maskd-strike-link.is-striking, .maskd-strike-link[aria-pressed='true']"
        );

        // Capture phase, so this runs before any bubble-phase click handler
        // on the link itself could change its pressed/current state first.
        struck.forEach(function (el) {
          if (el === link) return;
          el.classList.remove('is-striking');
          el.classList.add('is-unstriking');
        });

        link.classList.remove('is-striking', 'is-unstriking');

        void link.offsetWidth;

        link.classList.add('is-striking');
      },
      true
    );
  })();

  (function () {
    // [aria-current='page'] is already in the server-rendered markup on
    // first paint (the current nav link) -- which happens while the page
    // loader is still covering the screen. Trigger its draw-in animation once the
    // loader has actually hidden, so it's the first thing the visitor sees
    // rather than something that already finished behind the loader.
    function strikeInitialLinks() {
      document
        .querySelectorAll(".maskd-strike-link[aria-current='page'], .maskd-strike-link[aria-pressed='true']")
        .forEach(function (link) {
          link.classList.remove('is-striking', 'is-unstriking');
          void link.offsetWidth;
          link.classList.add('is-striking');
        });
    }

    if (document.getElementById('spider-loader')) {
      document.addEventListener('maskd:loader-hidden', strikeInitialLinks, { once: true });
    } else if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', strikeInitialLinks, { once: true });
    } else {
      strikeInitialLinks();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var drawer = document.getElementById('MaskdNavDrawer');
    if (!drawer) return;

    document.querySelectorAll('[data-drawer-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        drawer.showModal();
      });
    });

    document.querySelectorAll('[data-drawer-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        drawer.close();
      });
    });

    drawer.addEventListener('click', function (event) {
      if (event.target === drawer) {
        drawer.close();
      }
    });

    var searchOverlay = document.getElementById('MaskdSearchOverlay');
    var searchInput = searchOverlay ? searchOverlay.querySelector('[data-search-input]') : null;
    var searchResults = searchOverlay ? searchOverlay.querySelector('[data-search-results]') : null;

    if (searchOverlay) {
      var searchCloseTimer = null;

      var openSearch = function () {
        clearTimeout(searchCloseTimer);
        searchOverlay.showModal();
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            searchOverlay.classList.add('is-open');
          });
        });
        if (searchInput) searchInput.focus();
      };

      var closeSearch = function () {
        searchOverlay.classList.remove('is-open');
        clearTimeout(searchCloseTimer);
        searchCloseTimer = setTimeout(function () {
          searchOverlay.close();
        }, 350);
      };

      document.querySelectorAll('[data-search-open]').forEach(function (button) {
        button.addEventListener('click', openSearch);
      });

      document.querySelectorAll('[data-search-close]').forEach(function (button) {
        button.addEventListener('click', closeSearch);
      });

      searchOverlay.addEventListener('click', function (event) {
        if (event.target === searchOverlay) {
          closeSearch();
        }
      });

      searchOverlay.addEventListener('close', function () {
        searchOverlay.classList.remove('is-open');
        if (searchInput) searchInput.value = '';
        if (searchResults) searchResults.innerHTML = '';
      });
    }

    function linkWillNavigate(link, event) {
      // Only <a> elements can navigate the page at all.
      if (link.tagName !== 'A') return false;

      var href = link.getAttribute('href');
      // No href, or a bare "#" placeholder, does not navigate.
      if (!href || href === '#') return false;

      // A modifier key or target="_blank" opens the destination in a new
      // tab/window, leaving this page in place -- so the click animation
      // should still run here.
      if (event.metaKey || event.ctrlKey || event.shiftKey || link.target === '_blank') {
        return false;
      }

      return true;
    }

    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest('.maskd-strike-link');
        if (!link) return;

        // A click that will navigate away is always cut short by the page
        // unload, so its animation is barely visible -- but it still lands
        // alongside the destination page's own aria-current-driven
        // maskd-strike-draw animation, causing a visible double-strike.
        // Skip the click-driven classes entirely for navigating links and
        // let the page-load animation on the destination be the only one.
        if (linkWillNavigate(link, event)) return;

        // Scope to the nearest strike group (header nav, drawer nav, or
        // collection filters) so striking a link in one group never
        // un-strikes the active link in another.
        var group = link.closest('nav, .collection-page__filters') || document;
        var struck = group.querySelectorAll(
          ".maskd-strike-link[aria-current='page'], .maskd-strike-link.is-striking, .maskd-strike-link[aria-pressed='true']"
        );

        // Capture phase: for the theme toggle this runs before the button's
        // own bubble-phase click handler flips aria-pressed, so the
        // currently-active button is still detected here.
        struck.forEach(function (el) {
          if (el === link) return;
          el.classList.remove('is-striking');
          el.classList.add('is-unstriking');
        });

        link.classList.remove('is-striking', 'is-unstriking');

        void link.offsetWidth;

        link.classList.add('is-striking');
      },
      true
    );
  })();

  (function () {
    // [aria-current='page'] is already in the server-rendered markup on
    // first paint (the current nav link) -- which happens while the page
    // loader is still covering the screen. Trigger its draw-in animation once the
    // loader has actually hidden, so it's the first thing the visitor sees
    // rather than something that already finished behind the loader.
    function strikeInitialLinks() {
      document
        .querySelectorAll(".maskd-strike-link[aria-current='page'], .maskd-strike-link[aria-pressed='true']")
        .forEach(function (link) {
          link.classList.remove('is-striking', 'is-unstriking');
          void link.offsetWidth;
          link.classList.add('is-striking');
        });
    }

    if (document.getElementById('spider-loader')) {
      document.addEventListener('maskd:loader-hidden', strikeInitialLinks, { once: true });
    } else if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', strikeInitialLinks, { once: true });
    } else {
      strikeInitialLinks();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var AUTOPLAY_DELAY = 4000;
    var SWIPE_THRESHOLD = 40;
    var prefersReducedMotion = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
      : false;

    function watchImageLoad(container) {
      var img = container.querySelector('img');
      if (!img) {
        container.classList.add('is-loaded');
        return;
      }

      function markLoaded() {
        container.classList.add('is-loaded');
      }

      if (img.complete && img.naturalWidth > 0) {
        markLoaded();
      } else {
        img.addEventListener('load', markLoaded, { once: true });
        img.addEventListener('error', markLoaded, { once: true });
      }
    }

    function preload(item) {
      if (!item) return;
      watchImageLoad(item);
      var img = item.querySelector('img');
      if (img && img.loading === 'lazy') {
        img.loading = 'eager';
      }
    }

    function initGallery(gallery) {
      if (gallery.dataset.galleryInitialized === 'true') return;
      gallery.dataset.galleryInitialized = 'true';

      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
      var items = Array.prototype.slice.call(gallery.querySelectorAll('[data-media-item]'));
      var mediaMain = gallery.querySelector('.product-page__media-main');

      items.forEach(watchImageLoad);
      thumbs.forEach(watchImageLoad);

      if (!items.length) return;

      gallery.style.setProperty('--maskd-autoplay-duration', AUTOPLAY_DELAY + 'ms');

      var current = 0;

      function progressFor(thumb) {
        return thumb ? thumb.querySelector('[data-thumb-progress]') : null;
      }

      function select(index) {
        current = index;

        items.forEach(function (item) {
          var isActive = Number(item.dataset.mediaItem) === index;
          item.classList.toggle('product-page__media-item--active', isActive);
          item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        thumbs.forEach(function (thumb) {
          var isActive = Number(thumb.dataset.thumb) === index;
          thumb.classList.toggle('product-page__thumb--active', isActive);
          thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        preload(items[(index + 1) % items.length]);
      }

      function stopAutoplay() {
        thumbs.forEach(function (thumb) {
          var progress = progressFor(thumb);
          if (progress) progress.classList.remove('is-playing');
        });
      }

      function startAutoplay() {
        stopAutoplay();
        if (items.length < 2 || prefersReducedMotion) return;

        var progress = progressFor(thumbs[current]);
        if (!progress) return;

        // Force a reflow so re-adding the class always restarts the animation
        // from scratch, even when it's re-applied to the same element.
        void progress.offsetWidth;
        progress.classList.add('is-playing');
      }

      function handleProgressAnimationEnd(event) {
        if (event.animationName !== 'maskd-thumb-progress') return;
        if (event.target !== progressFor(thumbs[current])) return;

        select((current + 1) % items.length);
        startAutoplay();
      }

      gallery.addEventListener('animationend', handleProgressAnimationEnd);

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          select(Number(thumb.dataset.thumb));
          startAutoplay();
        });
      });

      if (mediaMain && items.length > 1) {
        var touchStartX = null;

        mediaMain.addEventListener(
          'touchstart',
          function (event) {
            touchStartX = event.touches[0].clientX;
          },
          { passive: true }
        );

        mediaMain.addEventListener(
          'touchend',
          function (event) {
            if (touchStartX === null) return;
            var deltaX = event.changedTouches[0].clientX - touchStartX;
            touchStartX = null;
            if (Math.abs(deltaX) < SWIPE_THRESHOLD) return;

            var next =
              deltaX < 0 ? (current + 1) % items.length : (current - 1 + items.length) % items.length;
            select(next);
            startAutoplay();
          },
          { passive: true }
        );
      }

      gallery.addEventListener('mouseenter', stopAutoplay);
      gallery.addEventListener('mouseleave', startAutoplay);

      function handleVisibilityChange() {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      }

      document.addEventListener('visibilitychange', handleVisibilityChange);

      gallery.maskdGalleryTeardown = function () {
        stopAutoplay();
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      };

      preload(items[1]);
      startAutoplay();
    }

    function initAllGalleries(root) {
      root.querySelectorAll('[data-product-gallery]').forEach(initGallery);
    }

    initAllGalleries(document);

    document.addEventListener('shopify:section:load', function (event) {
      initAllGalleries(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
        if (typeof gallery.maskdGalleryTeardown === 'function') {
          gallery.maskdGalleryTeardown();
        }
      });
    });
  })();

  (function () {
    var palette = document.querySelector('[data-palette]');
    if (!palette) return;

    var value = palette.querySelector('[data-palette-value]');
    var chosen = palette.querySelector('[data-palette-chosen]');
    var error = palette.querySelector('[data-palette-error]');
    var radios = palette.querySelectorAll('input[type="radio"]');

    function choose(text) {
      value.value = text;
      chosen.textContent = text;
      if (error) error.hidden = true;
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        choose(radio.value);
      });
    });

  })();

  (function () {
    var wrapper = document.querySelector('[data-product-recommendations]');
    if (!wrapper) return;

    var url = wrapper.dataset.url;
    if (!url) return;

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var recommendations = html.querySelector('[data-product-recommendations]');
        if (recommendations && recommendations.innerHTML.trim().length) {
          wrapper.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(function () {
        // Leave the wrapper empty if the recommendations request fails.
      });
  })();

  } catch(e) { console.error(e); }
})();
})();
